<div class="container-fluid col-xl-10 col-md-10 col-sm-12 px-auto">
    <div style="padding-left: 15px;" class="col-12 no-gutters">
        <app-layout-header class="col-12 no-gutters"></app-layout-header>
    </div>
    <div style="padding-left: 15px;" class="col-12 no-gutters" *ngIf="isShow">
        <br>
        <div class="row col-12 px-0">
            <div class="text-title col-12">Application Request Access</div>
            <div class="text-sub-title col-12">If you have access to the application you DO NOT need to request again. If you have access click on GO TO APPLICATION</div>
        </div>
        <br>
        <mat-tab-group mat-align-tabs="start" [selectedIndex]="selectedIndexTab">
            <mat-tab label="Supplier Apps">
                <div class="row col-12 no-gutters">
                    <div class="d-none d-md-block col-xl-2 col-md-3 col-sm-6 col-6 text-right pt-3"
                        style="font-weight: 600; font-size: 18px;">
                        All Supplier Apps
                    </div>
                    <div class="d-flex d-block d-md-none col-xl-2 col-md-2 col-sm-12 col-12 p-0 align-items-center"
                        style="overflow-x: auto; width: 100%; height: 50px;">
                        <div *ngFor="let batch of supplierList" class="col align-items-center pl-0 pr-0" style="min-width: 115px;">
                            <div class="text-center" [ngClass]="{ 'selected-sm': batch == selectedItem }"
                                (click)="onClick(batch)" style="cursor: pointer; font-size: 18px;">{{batch}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row col-12 mt-3 justify-content-center no-gutters p-0">
                    <div class="d-none d-md-block col-xl-2 col-md-2 col-sm-4 col-4 border-right">
                        <div *ngFor="let batch of supplierList" class="col-10 p-0">
                            <div class="text-right mb-3" [ngClass]="{ 'selected': batch == selectedItem }"
                                (click)="onClick(batch)" style="cursor: pointer; font-size: 18px;">{{batch}}
                            </div>
                        </div>
                    </div>
                    <app-clear-orbit-form *ngIf="selectedItem === 'Clear Orbit'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-clear-orbit-form>
                    <app-sdx-form *ngIf="selectedItem === 'Corella Collaboration & Qualifications'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-sdx-form>
                    <app-otm-form *ngIf="selectedItem === 'OTM'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-otm-form>
                    <app-i-supplier-form *ngIf="selectedItem === 'RACES iSupplier'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-i-supplier-form>
                    <app-renTT-form *ngIf="selectedItem === 'RenTT'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-renTT-form>
                    <app-renTM-form *ngIf="selectedItem === 'RenTM'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-renTM-form>
                    <!-- <app-supplier-connect-form *ngIf="selectedItem === 'Supplier Connect'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-supplier-connect-form> -->
                    <!-- <app-supplier-connect-form *ngIf="selectedItem === 'Ariba'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-supplier-connect-form> -->
                    <!-- <app-supplier-connect-form *ngIf="selectedItem === 'APSS'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-supplier-connect-form> -->
                    <app-spt-form *ngIf="selectedItem === 'OSCAR'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-spt-form>
                    <!-- <app-supplier-connect-form *ngIf="selectedItem === 'MTA'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-supplier-connect-form> -->
                    <app-quality-suites-form *ngIf="selectedItem === 'Quality Suite'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-quality-suites-form>
                    <app-intelex-supplier-audit-form *ngIf="selectedItem === 'Intelex Supplier Audit'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-intelex-supplier-audit-form>
                    <app-suppiler-portal-scorecard *ngIf="selectedItem === 'Supplier Portal / ScoreCard'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-suppiler-portal-scorecard>
                    <app-ge-tag-request-form *ngIf="selectedItem === 'GE ID Tag Request'"
                        class="row col-xl-10 col-md-10 col-sm-12 col-12 no-gutters"></app-ge-tag-request-form>
                </div>
            </mat-tab>
            <mat-tab label="Profile">
                <app-profile-form></app-profile-form>
            </mat-tab>
        </mat-tab-group>
    </div>
    <br>
</div>